import React, {FunctionComponent, HTMLProps, useEffect, useRef} from 'react'
import {useHistory} from 'react-router'

const getOrigin = (loc) =>
	loc.protocol + '//' + loc.hostname + (loc.port ? ':' + loc.port : '')

const isExternal = (anchorElement) =>
	getOrigin(location) !== getOrigin(anchorElement)

const click = (history, e) => {
	if (
		e.defaultPrevented ||
		e.button !== 0 ||
		e.altKey ||
		e.metaKey ||
		e.ctrlKey ||
		e.shiftKey ||
		e.currentTarget.target === '_blank' ||
		isExternal(e.currentTarget)
	)
		return
	e.preventDefault()
	const href = e.currentTarget.getAttribute('href')
	history.push(href)
}

export const Trusted: FunctionComponent<
	{
		children: string
	} & HTMLProps<HTMLDivElement>
> = ({children, ...props}) => {
	const history = useHistory()
	const dom = useRef<HTMLDivElement>()
	useEffect(() => {
		const clear = []
		const listener = click.bind(null, history)

		Array.from(dom.current.querySelectorAll('a')).forEach((link) => {
			const href = link.getAttribute('href')
			if (href && href.substr(-4) === '.pdf')
				link.setAttribute('target', '_blank')
			link.addEventListener('click', listener)
			clear.push(() => link.removeEventListener('click', listener))
		})

		for (const table of dom.current.querySelectorAll('table')) {
			const wrapper = document.createElement('div')
			wrapper.classList.add('theme_wysiwyg-table')
			table.replaceWith(wrapper)
			wrapper.appendChild(table)
		}

		return () => {
			clear.forEach((f) => f())
		}
	})
	return (
		<div
			{...props}
			ref={dom}
			dangerouslySetInnerHTML={{
				__html: Array.isArray(children) ? children[0] : children
			}}
		/>
	)
}
